// frontend/src/lib/numberStepper.js
//
// Task 3 (2026-06): pure step/clamp math for <NumberStepper>. Values are the
// controlled-input strings ('' means "unset"). Empty is treated as base 0 for
// stepping (so the first "+" yields the minimum valid value), then clamped to min.

export function stepValue(current, delta, min = 0) {
  const parsed = Number(current);
  const base = (current === '' || current === null || current === undefined || !Number.isInteger(parsed))
    ? 0
    : parsed;
  return String(Math.max(min, base + delta));
}

export function clampValue(raw, min = 0) {
  if (raw === '' || raw === null || raw === undefined) return '';
  const n = Number(raw);
  if (!Number.isInteger(n)) return '';
  return String(Math.max(min, n));
}
